const OnWait = (
  <h1>Loading...</h1>
);

export default OnWait;